import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  dataRequest,
  selectItemById,
  selectRequestsStateById
} from 'mt-react-common/common/reducers/objectCollection/reducer';

import MediumPreLoader from '../../Common/PreLoaders/MediumPreLoader';

const infoMaterialsCollectionRN =
  'infoMaterialsModule.collections.infoMaterialsCollection';

class InfoMaterialContent extends Component {
  constructor(props) {
    super(props);
    if (!props.selectInfoMaterial) {
      props.dataRequestInfoMaterial();
    }
  }

  render() {
    if (this.props.requestState.requestInProcess) {
      return <MediumPreLoader />;
    } else if (this.props.selectInfoMaterial) {
      return (
        <div>
          {this.props.showTitle ? (
            <h1>{this.props.selectInfoMaterial.title}</h1>
          ) : null}
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: this.props.selectInfoMaterial.content
            }}
          />
        </div>
      );
    }
    return <p>Инфо-материал {this.props.id} не найден.</p>;
  }
}

InfoMaterialContent.defaultProps = {
  selectInfoMaterial: null,
  showTitle: false
};

InfoMaterialContent.propTypes = {
  // IN
  id: PropTypes.string.isRequired,
  showTitle: PropTypes.bool,
  // CONNECT
  selectInfoMaterial: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
  }),
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired,
    lastStatusCode: PropTypes.number
  }).isRequired,
  dataRequestInfoMaterial: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  selectInfoMaterial: selectItemById(
    state,
    infoMaterialsCollectionRN,
    props.id
  ),
  requestState: selectRequestsStateById(
    state,
    infoMaterialsCollectionRN,
    props.id
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  dataRequestInfoMaterial: () =>
    dispatch(dataRequest(infoMaterialsCollectionRN, props.id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoMaterialContent);



// WEBPACK FOOTER //
// ./src/components/InfoMaterials/InfoMaterialContent/InfoMaterialContent.js